import React from 'react';
import { Button, Text } from '@fragments';
import { IconCheck, IconX } from '@tabler/icons-react';
import AccountSummary from '../../../AccountSummary';
import '../HandleInput/styles.scss';
import './styles.scss';

// "Is this you?" in the @ row itself: the handle is public data typed by the
// creator, so the profile is only built after they claim the account.
export default function AccountConfirm({ studio: s }) {
  const { t, locale, onboarding: o } = s;
  return <div className="studio-handle-field">
    <div className="studio-handle studio-handle--account" role="group" aria-labelledby="studio-account-question">
      <AccountSummary account={o.record.account} t={t} locale={locale} markId="studio-onboarding-mark" brief />
      <Button variant="rounded" color="overlay" size="medium" icon={<IconX />} aria-label={t('onboardingNotMe')} tooltip={t('onboardingNotMe')} onClick={o.rejectAccount} />
      <Button data-autofocus className="studio-handle__submit" variant="rounded" color="inverse" size="medium" startIcon={<IconCheck />} onClick={o.confirmAccount}>{t('onboardingItsMe')}</Button>
    </div>
    <div className="studio-handle-field__meta">
      <Text.caption id="studio-account-question" contrast={6}>{t('onboardingFound')}</Text.caption>
    </div>
  </div>;
}
